import React, { useState } from "react"
import ClozeSentence from "./ClozeSentence";
import Icon from "./Icon";

export default function QuickDemo({ demoSentences }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showResult, setShowResult] = useState(null);

  const currentSentence = demoSentences[currentIndex];

  const handleNextClick = () => {
    setCurrentIndex((prev) => (prev + 1) % demoSentences.length)
    setSelectedOption(null)
    setShowResult(null)
  };

  const handleOptionClick = (option) => {
    if (showResult) { // return // Prevent clicking after answer is shown
      handleNextClick();
    }

    setSelectedOption(option)

    if (option === currentSentence.cloze) {
      setShowResult("correct")
      // setTimeout(() => {
      //   setCurrentIndex((prev) => (prev + 1) % demoSentences.length)
      //   setSelectedOption(null)
      //   setShowResult(null)
      // }, 1500)
    } else {
      setShowResult("incorrect")
      setTimeout(() => {
        setShowResult(null)
        setSelectedOption(null)
      }, 1000)
    }
  }

  const playAudio = () => {
    const audio = new Audio(currentSentence.ttsAudioUrl);
    audio.play();
  };

  return (
    <div>
      <div style={{ alignItems: "flex-start", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <div className="label label-default" style={{ alignItems: "center", display: "flex", flexDirection: "row", gap: 8 }}><img src={currentSentence.flagUrl} height={16} /><span style={{ fontSize: "14px" }}>{currentSentence.language}</span></div>
        <div>
          <button className="btn btn-default" onClick={playAudio}><Icon name="volume-up" /></button>
        </div>
      </div>
      
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "2em" }}>{showResult === "correct" ? <ClozeSentence text={currentSentence.text} /> : currentSentence.text.replace(/{{.+}}/, "_____")}</p>
        <p>{currentSentence.translation}</p>
        <br />
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 20, justifyContent: "center", marginBottom: 20 }}>
          {currentSentence.multipleChoiceOptions.map((option) => {
            const isSelected = selectedOption === option;
            const isCorrect = option === currentSentence.cloze;
            const showCorrect = showResult === "correct" && isSelected;
            const showIncorrect = showResult === "incorrect" && isSelected;

            return (
              <button
                className={`btn btn-lg btn-default ${showCorrect ? "btn-success" : ""} ${showIncorrect ? "btn-danger" : ""}`}
                key={option}
                onClick={() => handleOptionClick(option)}
                style={{ width: 300 }}
              >
                {option}
                {showCorrect && <Icon name="ok" style={{ paddingLeft: 10 }} />}
                {showIncorrect && <Icon name="remove" style={{ paddingLeft: 10 }} />}
              </button>
            )
          })}
        </div>
        <button className="btn btn-success btn-lg joystix" disabled={showResult === "correct" ? false : true} onClick={handleNextClick} style={{ opacity: showResult === "correct" ? 1 : 0 }}>Next</button>
        <div style={{ display: "flex", flexDirection: "row", gap: 10, justifyContent: "center", marginTop: 20 }}>
          {demoSentences.map((_, index) => (
            <div
              key={index}
              style={{ backgroundColor: index === currentIndex ? "#000" : "#efefef", borderRadius: "calc(infinity * 1px)", height: 10, width: 10 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

